import { render, staticRenderFns } from "./rightTab.vue?vue&type=template&id=9310f922&scoped=true"
import script from "./rightTab.vue?vue&type=script&lang=js"
export * from "./rightTab.vue?vue&type=script&lang=js"
import style0 from "./rightTab.vue?vue&type=style&index=0&id=9310f922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9310f922",
  null
  
)

export default component.exports